import { Fragment } from "react";
import { containerClasses } from "../../styles/containers";
import { Text } from "./Text";
import { Stack } from "./Stack";
import { Button } from '../FormControls/Button';
import { ArrowBackIos , Person, AccountBalance, Receipt } from '@mui/icons-material'
import { useDispatch, useSelector } from 'react-redux';
import { jump } from "../../../main/slices/routerSlice";
import { useCookies } from "react-cookie";
import { useState, useEffect } from "react";

const RenderList = ({ classes, items, onSelect }) => {
    const contClass = containerClasses();
    const dispatch = useDispatch();
    const [selected, setSelected] = useState(null);
    const [cookies, setCookies] = useCookies(["source", "idTrxEditing"]);
    const store = useSelector(({ store }) => store);

    const handleProcedure = (type) => {
      setCookies("procedure", type, { path: "/" });
      setCookies("registerFromList", true, { path: true });
      if (type === "register") {
        dispatch(jump({ current: 2, direction: "forward", }));
      }

      return true;
    };

    classes = classes.reduce((cls, c) => cls + " " + contClass[c], "");

    if(!items.length){
        return (
          <>
            <div style={{ marginBottom: "18rem" }}></div>
            <Fragment>
                <Text classes={["center", "mediumText", "alignContent"]}>No hay operadores agregados a este comercio.</Text>
            </Fragment>
            <Button 
                style={{
                    position: "fixed",
                    top: "1.5rem",
                }} 
                classes={["btnBackward", "alignBtnContent", "purpleBtn"]} 
                onClick={() => dispatch(jump({ current: 8, direction: "backward" })) }>
                <ArrowBackIos  fontSize='small' />
            </Button>
          </>
        );
    }

    useEffect(() => {
        if (cookies.idTrxEditing && cookies.idTrxEditing !== "" && !selected) {
          setSelected(cookies.idTrxEditing);
          setCookies("idTrxEditing", "");
        }
    }, [cookies.idTrxEditing, selected]);

    return (
      <>
        <Fragment>
          <div style={{ padding: "0 0.2rem" }}>
              <Text classes={["title", "center"]}> {""} Operadores {""}</Text>
              <div style={{ width: "100%", height: "100%", overflowY: "scroll"}}>
                    {items.map((item, i) => 
                        <div key={i} className={`${contClass.listTransactions} ${item.id === selected ? contClass.selectedItem : ""}`}>
                            <Stack style={{ width: "325px"}} flex={{ flexDirection: "Column", display: "flex", alignItems: "start" }}> 
                                <Text classes={["smallTitle"]} style={{ color: "#000" }}>
                                    Id: {`${item.idWLD.slice(-8)}-${i+1}`}
                                </Text>
                                <Text classes={["smallTitle"]} style={{ color: "#000" }}>
                                    Correo: {`${item.email}`}
                                </Text>
                            </Stack>
                        </div> 
                     )}
              </div>
          </div>
        </Fragment>                                                         
        <Button 
            style={{
                position: "fixed",
                top: "1.5rem",
            }} 
            classes={["btnBackward", "alignBtnContent", "purpleBtn"]} 
            onClick={() => dispatch(jump({ current: 8, direction: "backward" })) }
        >
            <ArrowBackIos />
        </Button>
      </>
    );
}

export const ListUsers = ({ classes = [], items = [], onSelect = () => {} }) => (
    <RenderList {...{ classes, items, onSelect }} />

);